export const BASE_URL = 'https://backend.joint-loading.com';
export const ACTIVITIES = '/orthoload_get_activities?';
export const PATIENTS = '/orthoload_get_patients?';
export const PARAMETERS = '/orthoload_get_parameters?';
export const DATA = '/orthoload_get_data?';
export const FILES = '/orthoload_get_files?';
export const SEARCH = '/orthoload_search?';
